import MainLayout from '../layouts/main';
import CardsContainer from './container';

function CardPage() {
  return (
    <MainLayout withFooter>
      <CardsContainer />
    </MainLayout>
  );
}

export default CardPage;
